import AdminRoutes from '@/app/routes/guards/AdminRoutes'
import { ROUTER } from '@/shared/config'
import React from 'react'
import { Navigate } from 'react-router-dom'
import { defineEntry, toRoute } from './routeEntry'

// menuKey = đường dẫn menu (routerLink từ BE, xem buildMenuFromTabs.ts) của màn; trang chi tiết dùng khoá màn cha.
export const adminPages = [
  defineEntry({
    path: ROUTER.QUAN_LY_PHAN_QUYEN,
    page: React.lazy(() => import('@/features/role/pages')),
    menuKey: ROUTER.QUAN_LY_PHAN_QUYEN,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.THAM_SO_HE_THONG,
    page: React.lazy(() => import('@/features/systemkey')),
    menuKey: ROUTER.THAM_SO_HE_THONG,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.QUAN_LY_NGUOI_DUNG,
    page: React.lazy(() => import('@/features/user')),
    props: { pageTitle: 'Quản lý người dùng' },
    menuKey: ROUTER.QUAN_LY_NGUOI_DUNG,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.LUONG_KY,
    page: React.lazy(() => import('@/features/sign-flow')),
    menuKey: ROUTER.LUONG_KY,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: `${ROUTER.LUONG_KY}/:id`,
    page: React.lazy(() =>
      import('@/features/sign-flow').then((m) => ({
        default: m.SignFlowDetailPage,
      }))
    ),
    menuKey: ROUTER.LUONG_KY,
    skeletonKind: 'detail',
  }),
  defineEntry({
    path: ROUTER.LOAI_VAN_BANG_CHI_TIET,
    page: React.lazy(() =>
      import('@/features/doc-type').then((m) => ({
        default: m.DocTypeDetailPage,
      }))
    ),
    menuKey: ROUTER.LOAI_VAN_BANG,
    skeletonKind: 'detail',
  }),
  defineEntry({
    path: ROUTER.HO_SO_CHI_TIET,
    page: React.lazy(() => import('@/features/dossier-assignment/pages/DossierDetailPage')),
    menuKey: ROUTER.QUAN_LY_HO_SO,
    skeletonKind: 'detail',
  }),
  defineEntry({
    path: ROUTER.HO_SO_PHAT_HANH,
    page: React.lazy(() => import('@/features/dossier-assignment/pages/PublishDossierPage')),
    menuKey: ROUTER.QUAN_LY_HO_SO,
    skeletonKind: 'detail',
  }),
  defineEntry({
    path: ROUTER.MY_DOSSIER_CHI_TIET,
    page: React.lazy(() => import('@/features/my-dossiers/pages/MyDossierDetailPage')),
    menuKey: ROUTER.MY_DOSSIERS,
    skeletonKind: 'detail',
  }),
  defineEntry({
    path: ROUTER.TAI_KHOAN_DAI_DIEN,
    page: React.lazy(() => import('@/features/user')),
    props: {
      fixedAccountType: 1,
      hideDepartment: true,
      pageTitle: 'Tài khoản đại diện',
      addressMultiLine: true,
    },
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.CHU_VAN_BANG_THIEU_LIEN_HE,
    page: React.lazy(() => import('@/features/document-holders')),
    menuKey: ROUTER.CHU_VAN_BANG_THIEU_LIEN_HE,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.TAI_KHOAN_CONG_DAN,
    page: React.lazy(() => import('@/features/user')),
    props: {
      fixedAccountType: 2,
      hideDepartment: true,
      pageTitle: 'Tài khoản công dân',
      addressMultiLine: true,
    },
    menuKey: ROUTER.TAI_KHOAN_CONG_DAN,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.HANG_CHO_KY,
    page: React.lazy(() => import('@/features/sign-queue')),
    menuKey: ROUTER.HANG_CHO_KY,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.QUAN_LY_HO_SO,
    page: React.lazy(() => import('@/features/dossier-assignment')),
    menuKey: ROUTER.QUAN_LY_HO_SO,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.MY_DOSSIERS,
    page: React.lazy(() => import('@/features/my-dossiers/pages/MyDossiersPage')),
    menuKey: ROUTER.MY_DOSSIERS,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.VAN_BAN_DA_KY,
    page: React.lazy(() => import('@/features/dossier-signed')),
    menuKey: ROUTER.VAN_BAN_DA_KY,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.KHO_VAN_BANG,
    page: React.lazy(() => import('@/features/credential-store')),
    menuKey: ROUTER.KHO_VAN_BANG,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.GUI_VAN_BAN,
    page: React.lazy(() => import('@/features/dispatch-send')),
    menuKey: ROUTER.GUI_VAN_BAN,
    skeletonKind: 'form',
  }),
  defineEntry({
    path: ROUTER.NHAT_KY_HE_THONG,
    page: React.lazy(() => import('@/features/system-log')),
    menuKey: ROUTER.NHAT_KY_HE_THONG,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.LOAI_VAN_BANG,
    page: React.lazy(() => import('@/features/doc-type')),
    menuKey: ROUTER.LOAI_VAN_BANG,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.OUTBOX_MONITOR,
    page: React.lazy(() => import('@/features/outbox-monitor')),
    menuKey: ROUTER.OUTBOX_MONITOR,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.BAO_CAO,
    page: React.lazy(() => import('@/features/report-aggregate')),
    menuKey: ROUTER.BAO_CAO,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.LOAI_HO_SO,
    page: React.lazy(() =>
      import('@/features/dossier-type').then((m) => ({
        default: m.DossierTypePage,
      }))
    ),
    menuKey: ROUTER.LOAI_HO_SO,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.LOAI_HO_SO_CAU_HINH,
    page: React.lazy(() =>
      import('@/features/dossier-type').then((m) => ({
        default: m.DossierDocumentTypeConfigPage,
      }))
    ),
    menuKey: ROUTER.LOAI_HO_SO,
    skeletonKind: 'detail',
  }),
  defineEntry({
    path: ROUTER.CAU_HINH_VUNG_KY,
    page: React.lazy(() => import('@/features/signature-config')),
    menuKey: ROUTER.CAU_HINH_VUNG_KY,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.DUYET_CHU_KY,
    page: React.lazy(() =>
      import('@/features/user-signature').then((m) => ({
        default: m.SignatureReviewContainer,
      }))
    ),
    menuKey: ROUTER.DUYET_CHU_KY,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.CHUC_VU,
    page: React.lazy(() => import('@/features/position')),
    menuKey: ROUTER.CHUC_VU,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.QUAN_LY_THONG_BAO,
    page: React.lazy(() => import('@/features/notification-admin')),
    menuKey: ROUTER.QUAN_LY_THONG_BAO,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.TRANG_CHU_QUAN_TRI,
    page: React.lazy(() => import('@/features/dashboard')),
    menuKey: ROUTER.TRANG_CHU_QUAN_TRI,
  }),
  defineEntry({
    path: ROUTER.IMPORT_TAI_LIEU,
    page: React.lazy(() => import('@/features/document-import')),
    menuKey: ROUTER.IMPORT_TAI_LIEU,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.CA_TIN_CAY,
    page: React.lazy(() => import('@/features/trusted-ca')),
    menuKey: ROUTER.CA_TIN_CAY,
    skeletonKind: 'table',
  }),
]

// Màn bị loại khỏi menu (buildMenuFromTabs) nên chỉ chuyển hướng về quản lý người dùng.
const REDIRECTED = [ROUTER.TAI_KHOAN_DAI_DIEN, ROUTER.TAI_KHOAN_CONG_DAN]

export const adminRoutes = [
  {
    element: <AdminRoutes />,
    children: [
      ...adminPages.map((entry) =>
        REDIRECTED.includes(entry.path)
          ? {
              path: entry.path,
              element: <Navigate to={ROUTER.QUAN_LY_NGUOI_DUNG} replace />,
            }
          : toRoute(entry)
      ),
      {
        path: '/ho-so-da-ky',
        element: <Navigate to={ROUTER.VAN_BAN_DA_KY} replace />,
      },
    ],
  },
]
